// removed by extract-text-webpack-plugin
module.exports = {"cartProduct":"CartProduct-m__cartProduct___17jny","cartProduct_desc":"CartProduct-m__cartProduct_desc___3TOJz","cartProductDesc":"CartProduct-m__cartProduct_desc___3TOJz","cartProduct_name":"CartProduct-m__cartProduct_name___3i68k","cartProductName":"CartProduct-m__cartProduct_name___3i68k"};


//////////////////
// WEBPACK FOOTER
// ./components/cartProduct/CartProduct.m.sass
// module id = g3ij
// module chunks = 0